import { render } from "./Matrix.vue?vue&type=template&id=1c356a87&scoped=true"
import script from "./Matrix.vue?vue&type=script&lang=js"
export * from "./Matrix.vue?vue&type=script&lang=js"

import "./Matrix.vue?vue&type=style&index=0&id=1c356a87&scoped=true&lang=css"

import exportComponent from "D:\\project\\survey-slp-house\\survey-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c356a87"]])

export default __exports__